import { useMemo } from "react";
import { routes } from "../../../app/routes";

import {
  TopbarSubmenu,
  IconDefinitions,
  TopbarMenuItem,
} from "../../../components";
import { useUrlParams } from "../../../hooks";

export const SubscriptionTopbar = (props: any) => {
  const id = useUrlParams("id");

  const submenuItems: TopbarMenuItem[] = useMemo(
    (): TopbarMenuItem[] => [
      {
        label: "Back",
        icon: IconDefinitions.back,
        url: routes.host.subscription.index,
      },
      {
        label: "Details",
        icon: IconDefinitions.squareInfo,
        url: routes.host.subscription.details,
        activeMatch: routes.host.subscription.details,
        activeMatchExact: true,
        params: new Map([["id", id]]),
      },
      {
        label: "Billing History",
        icon: IconDefinitions.moneyBill,
        url: routes.host.subscription.history,
        activeMatch: routes.host.subscription.history,
        activeMatchExact: true,
        params: new Map([["id", id]]),
      },
      {
        label: "Billing Info",
        icon: IconDefinitions.infoCircle,
        url: routes.host.subscription.billingInfo,
        activeMatch: routes.host.subscription.billingInfo,
        activeMatchExact: true,
        params: new Map([["id", id]]),
      },
      ],
    [id]
  );

  return <TopbarSubmenu className="p-0" items={submenuItems} />;
};

export default SubscriptionTopbar;

